import React, { useState } from 'react';

import { FormattedMessage } from 'react-intl';
import { translations } from '@/locale';
import Modal from '@/components/Modal';
import InviteOrgMemberModal from '@/components/Modal/InviteOrgMemberModal';
import Refresh from '@/components/Refresh';

import Typography from '@/components/Typography';
import { fetchUsers } from '@/services/api/users';
import ActivityBadge from '@/components/Badge/ActivityBadge';

import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import PaginatedTable from '@/components/ui/paginated';
import { TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

import { urls } from '@/constants';
import UserListTable from '@/components/UserListTable/UserListTable';

export interface Props {
  id: string;
}

const OrganizationMembersTab: React.FC<Props> = ({ id }) => {
  const [term, setTerm] = useState('');

  return (
    <Refresh>
      {({ refresh, key }) => (
        <div className="space-y-4">
          <div className="flex space-x-4">
            <Input placeholder="Filter by name or email" onChange={(e) => setTerm(e.target.value)} />

            <Modal modal={InviteOrgMemberModal} orgId={id} onMemberInvited={refresh}>
              {({ open }) => (
                <Button variant="outline" onClick={open}>
                  Invite member
                </Button>
              )}
            </Modal>
          </div>

          <UserListTable
            key={JSON.stringify({ term, key })}
            source={(page, size) =>
              fetchUsers(page, size, {
                organisationId: id,
                vendorId: null,
                term: term,
                joinedAfter: new Date(0),
                joinedBefore: new Date()
              })
            }
          />
        </div>
      )}
    </Refresh>
  );
};

export default OrganizationMembersTab;
